function ConfirmButtons(props) {
    const {staff, correctData, confirmData, confirmed} = props;
    if(!confirmed && staff !== true)
    return(
        <div className="buttons">
            <button className="btn correct-data-btn" onClick={correctData}>Popraw dane</button>
            <div>
                <button onClick={confirmData} className="btn confirm-btn">Potwierdź</button>
                <p>Po potwierdzeniu otrzymasz sms z unikalnym numerem, który należy wpisać w polu 'Numer potwierdzający'</p>
            </div>
        </div>
    )
}

export default ConfirmButtons